const lazyLoadHandler = () => {
  let lazyloadThrottleTimeout;
  const images = document.querySelectorAll('.lazy');

  if (lazyloadThrottleTimeout) {
    clearTimeout(lazyloadThrottleTimeout);
  }

  lazyloadThrottleTimeout = setTimeout(() => {
    const scrollTop = window.pageYOffset;
    Array.prototype.forEach.call(images, (img) => {
      if (img.offsetTop < (window.innerHeight + scrollTop)) {
        if (img.dataset.src) {
          img.src = img.dataset.src;
        } else {
          const classNames = img.parentNode.classList;
          if (classNames.toString().indexOf('object-fit') === -1) {
            img.src = img.getAttribute('data-src-ie11');
          }
        }
        img.classList.remove('lazy');
        img.classList.add('image-loaded');
      }
    });

    if (images.length === 0) {
      document.removeEventListener('scroll', lazyLoadHandler);
      window.removeEventListener('resize', lazyLoadHandler);
      window.removeEventListener('orientationChange', lazyLoadHandler);
    }
  }, 20);
};

let activeObserver = null;

const lazyload = (options = {}) => {
  const { rootMargin = '100px', placeholderClass = '' } = options;

  if ('IntersectionObserver' in window) {
    const images = document.querySelectorAll('.lazy');

    const observerOptions = {
      rootMargin,
      threshold: [0],
    };

    if (activeObserver) {
      activeObserver.disconnect();
    }

    const imageObserver = new IntersectionObserver((entries) => {
      Array.prototype.forEach.call(entries, (entry) => {
        if (entry.isIntersecting) {
          const image = entry.target;
          let srcset = image.dataset.src;
          if (!srcset) {
            srcset = image.getAttribute('data-srcset');
          }
          if (srcset !== null) {
            const markReady = () => {
              image.classList.add('image-ready');
              if (placeholderClass) {
                image.classList.remove(placeholderClass);
              }
            };
            image.addEventListener('load', markReady, { once: true });
            image.addEventListener('error', markReady, { once: true });

            if (placeholderClass) {
              image.classList.add(placeholderClass);
            }
            image.srcset = srcset;
            image.classList.remove('lazy');
            image.classList.add('image-loaded');
            imageObserver.unobserve(image);
          }
        }
      });
    }, observerOptions);

    activeObserver = imageObserver;

    images.forEach((image) => {
      imageObserver.observe(image);
    });
  } else {
    lazyLoadHandler();
    document.addEventListener('scroll', lazyLoadHandler);
    window.addEventListener('resize', lazyLoadHandler);
    window.addEventListener('orientationChange', lazyLoadHandler);
  }
};

export default lazyload;
